import getComponent from './get-component';

const getFieldTypes = () => {
  const component = getComponent();
  return component.getFieldTypes();
};

export default getFieldTypes;
